import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e373ad2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { computed, nextTick, onMounted, reactive, ref } from 'vue'

interface Props {
  data: any
  size?: number | string
  vertical?: boolean
  // 通知栏高度，单位px
  height?: number | string
  // 动画延迟时间 (s)
  delay?: number
  // 滚动速率 (px/s)
  spped?: number
  suffixIcon?: string
  prefixIcon?: string
  // 通知文本颜色
  color?: string
  // 通知背景色
  background?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'notice-bar',
  props: {
    data: null,
    size: { default: 14 },
    vertical: { type: Boolean },
    height: { default: 40 },
    delay: { default: 1000 },
    spped: { default: 100 },
    suffixIcon: null,
    prefixIcon: null,
    color: { default: '--color-warning' },
    background: { default: 'var(--color-warning-light-9)' }
  },
  setup(__props: any) {

const props = __props as { data: any, size: number | string, vertical?: boolean, height: number | string, delay: number, spped: number, suffixIcon?: string, prefixIcon?: string, color: string, background: string }


console.log(props.data)

const state = reactive({
  boxWidth: 0,
  textWidth: 0,
  oneTime: 0,
  twoTime: 0,
  order: 1
})
const boxRef = ref({} as HTMLDivElement)
const textRef = ref({} as HTMLDivElement)

const interval = computed(() => (props.delay > 2000 ? props.delay : 2000))

// 初始化 animation 各项参数
const initAnimation = () => {
  nextTick(() => {
    state.boxWidth = boxRef.value.offsetWidth
    state.textWidth = textRef.value.offsetWidth
    document.styleSheets[0].insertRule(`@keyframes oneAnimation {0% {left: 0px;} 100% {left: -${state.textWidth}px;}}`)
    document.styleSheets[0].insertRule(
      `@keyframes twoAnimation {0% {left: ${state.boxWidth}px;} 100% {left: -${state.textWidth}px;}}`
    )
    computeAnimationTime()
    setTimeout(() => {
      changeAnimation()
    }, props.delay)
  })
}

// 计算 animation 滚动时长
const computeAnimationTime = () => {
  state.oneTime = state.textWidth / props.spped
  state.twoTime = (state.textWidth + state.boxWidth) / props.spped
}

// 改变 animation 动画调用
const changeAnimation = () => {
  if (state.order === 1) {
    textRef.value.style.cssText = `animation: oneAnimation ${state.oneTime}s linear; opactity: 1;}`
    state.order = 2
  } else {
    textRef.value.style.cssText = `animation: twoAnimation ${state.twoTime}s linear infinite; opacity: 1;`
  }
}

// 监听 animation 动画的结束
const listenerAnimationend = () => {
  textRef.value.addEventListener(
    'animationend',
    () => {
      changeAnimation()
    },
    false
  )
}

// 页面加载时
onMounted(() => {
  if (props.vertical) return
  initAnimation()
  listenerAnimationend()
})

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_u_icon = _resolveComponent("u-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "u-notice-bar",
    style: _normalizeStyle({ background: __props.background, height: `${__props.height}px` })
  }, [
    (__props.vertical)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_carousel, {
            height: "40px",
            loop: true,
            direction: "vertical",
            autoplay: true,
            "indicator-position": "none",
            interval: _unref(interval)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["interval"])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({ color: __props.color, fontSize: `${__props.size}px` }),
          class: "u-notice-bar-wrap"
        }, [
          (__props.prefixIcon)
            ? (_openBlock(), _createBlock(_component_u_icon, {
                key: 0,
                name: __props.prefixIcon
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref_key: "boxRef",
            ref: boxRef,
            class: "text-box"
          }, [
            _createElementVNode("div", {
              ref_key: "textRef",
              ref: textRef,
              class: "text"
            }, _toDisplayString(__props.data), 513)
          ], 512),
          (__props.suffixIcon)
            ? (_openBlock(), _createBlock(_component_u_icon, {
                key: 1,
                name: __props.suffixIcon
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ], 4))
  ], 4))
}
}

})